module.exports = __webpack_public_path__ + "static/body-c0a8ec991185e5ed063973323ccb764d.png";